import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <nav className="w-full bg-[#fffefc] py-4 px-6 md:px-12 lg:px-24 shadow-sm fixed top-0 z-50 border-b border-[#E8DFD8]" data-id="element-149">
      <div className="flex justify-between items-center" data-id="element-150">
        <div className="flex items-center" data-id="element-151">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3N41fDpegCrAJ1F4sfjWft/Screenshot_2025-11-25_at_19.25.33.png" alt="Hermo" className="h-8" data-id="element-152" />
        </div>
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-153">
          <a href="#how-it-works" className="text-[#6B5244] hover:text-[#553116] transition-colors" data-id="element-154">
            How it Works
          </a>
          <a href="#testimonials" className="text-[#6B5244] hover:text-[#553116] transition-colors" data-id="element-155">
            Testimonials
          </a>
          <a href="#faq" className="text-[#6B5244] hover:text-[#553116] transition-colors" data-id="element-156">
            FAQ
          </a>
          <a href="https://app.hermo.ai" className="bg-[#553116] text-white px-6 py-2 rounded-full font-medium hover:bg-[#442710] transition-colors shadow-md" data-id="element-157">
            Get Started
          </a>
        </div>
        {/* Mobile Menu Button */}
        <div className="md:hidden" data-id="element-158">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-[#6B5244]" data-id="element-159">
            {isMenuOpen ? <X size={24} data-id="element-160" /> : <Menu size={24} data-id="element-161" />}
          </button>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-[#fffefc] mt-4 py-4 px-4 rounded-lg shadow-md border border-[#E8DFD8]" data-id="element-162">
          <div className="flex flex-col space-y-4" data-id="element-163">
            <a href="#how-it-works" className="text-[#6B5244] hover:text-[#553116] transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-164">
              How it Works
            </a>
            <a href="#testimonials" className="text-[#6B5244] hover:text-[#553116] transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-165">
              Testimonials
            </a>
            <a href="#faq" className="text-[#6B5244] hover:text-[#553116] transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-166">
              FAQ
            </a>
            <a href="https://app.hermo.ai" className="bg-[#553116] text-white px-6 py-2 rounded-full font-medium hover:bg-[#442710] transition-colors shadow-md text-center" onClick={() => setIsMenuOpen(false)} data-id="element-167">
              Get Started
            </a>
          </div>
        </div>}
    </nav>;
}